<ion-spinner name="crescent" color="primary"></ion-spinner>
